// import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { ThemeProvider } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";
import { SwitchScreenProvider } from "./hooks/SwitchScreenContext";
import ErrorBoundary from "./components/ErrorBoundary";
import IdentityBootstrap from "./identity/IdentityBootstrap";

import "./styles/responsive.css";

import ThemeContextProvider from "./style/theme";

import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Register from "./pages/Register";
// import Home from "./pages/Home";
// import PersnonalInfo from "./pages/PersnonalInfo";
import UserProfile from "./pages/UserProfile";
import ComingSoon from "./components/ComingSoon";
import PersonalInfo from "./pages/OldPersonalInfo";
import Home from "./pages/OldHome";
import PaymentSubscrpition from "./pages/PaymentSubscrpition";

function App() {
  const storedUser = localStorage.getItem("user");
  const isAuthenticated = !!storedUser;
  console.log("isAuthenticated:", isAuthenticated);

  return (
    <ErrorBoundary>
      <ThemeContextProvider>
        <SwitchScreenProvider>
          <IdentityBootstrap><BrowserRouter>
            <div className="App">
              <Routes>
                <Route
                  path="/login"
                  element={
                    isAuthenticated ? <Navigate to="/" replace /> : <Login />
                  }
                />
                <Route
                  path="/signup"
                  element={
                    isAuthenticated ? <Navigate to="/" replace /> : <Register />
                  }
                />

                <Route
                  path="/*"
                  element={
                    isAuthenticated ? (
                      <Navbar>
                        <Routes>
                          <Route path="/" element={<Home />} />
                          <Route path="/personal" element={<UserProfile />} />
                          <Route
                            path="/organizations"
                            element={<ComingSoon />}
                          />
                          <Route
                            path="/subscrpition"
                            element={<PaymentSubscrpition />}
                          />

                          <Route
                            path="*"
                            element={<Navigate to="/" replace />}
                          />
                        </Routes>
                      </Navbar>
                    ) : (
                      <Navigate to={`/login${window.location.search}`} replace />
                    )
                  }
                />
              </Routes>
            </div>
          </BrowserRouter></IdentityBootstrap>
        </SwitchScreenProvider>
      </ThemeContextProvider>
    </ErrorBoundary>
  );
}

export default App;
